import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query"
import { getStudentTeachers } from "./api"

export const studentTeachersQueryOptions = (studentNo: string) =>
    queryOptions({
        queryKey: ['studentTeachers', studentNo],
        queryFn: () => getStudentTeachers(studentNo),
    })

export function useStudentTeachers(studentNo: string) {
    return useQuery(studentTeachersQueryOptions(studentNo))
}

export function useStudentTeachersSuspense(studentNo: string) {
    return useSuspenseQuery(studentTeachersQueryOptions(studentNo))
}
